import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

import {
  getBlocSystemDocumentTemplatesDocuments,
  getPublishedTemplateRecord
} from "pstat-anywhere/components/system_document_templates/utils";
import { environment } from "pstat-anywhere/relay";

const mutation = graphql`
  mutation UnpublishTemplateMutation(
    $input: UnpublishSystemDocumentTemplateInput!
  ) {
    unpublishSystemDocumentTemplate(input: $input) {
      ok
      result
      error
    }
  }
`;

function unpublishTemplate(templatePk, blocPk, location, callback) {
  const variables = {
    input: {
      systemDocumentTemplate: templatePk,
      bloc: blocPk
    }
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => callback(response, errors),
    onError: error => {
      throw new Error(error);
    },
    updater: (store, data) => {
      if (!data?.unpublishSystemDocumentTemplate?.ok) {
        return;
      }

      const storeGetter = blocPk
        ? getBlocSystemDocumentTemplatesDocuments
        : getPublishedTemplateRecord;
      const storedValues = storeGetter(store, templatePk, location);

      if (!storedValues) {
        return;
      }

      const totalCount = storedValues.getValue("totalCount");
      storedValues.setValue(totalCount - 1, "totalCount");

      const edgesRecords = storedValues.getLinkedRecords("edges");

      // Filter functions
      const filterByTemplatePk = item =>
        item.getLinkedRecord("node").getValue("pk") !== templatePk;
      const filterByBlocPk = item => {
        const node = item.getLinkedRecord("node");
        const bloc = node.getLinkedRecord("bloc");
        return bloc ? bloc.getValue("pk") !== blocPk : true;
      };

      const filterFunction = blocPk ? filterByBlocPk : filterByTemplatePk;

      const updatedRecords = edgesRecords.filter(filterFunction);
      storedValues.setLinkedRecords(updatedRecords, "edges");
    }
  });
}

export default unpublishTemplate;
